export default {
  notificationsList: [],
};
